const boardSize = 16
export default boardSize;